import script from "./MultimediaFormModal.vue?vue&type=script&setup=true&lang=js"
export * from "./MultimediaFormModal.vue?vue&type=script&setup=true&lang=js"

import "./MultimediaFormModal.vue?vue&type=style&index=0&id=70621ab6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-70621ab6"]])

export default __exports__